<template>
  <div>
    <h4 class="display-1 font-weight-black pt-6 grey--text text--lighten-1">
      {{ subtitle }}
    </h4>
    <h3 class="display-2 font-weight-medium pb-4">{{ title }}</h3>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    subtitle: String,
    title: String
  }
};
</script>
